import { apiAsync } from '../../../../common/helpers'

const queryJurisdictionsWithMultipleTippedWages = async () => {
  const url = 'jurisdiction?filterMultipleTippedWages=true&product=wageRates&collections=topics&useGeoJurisdictions=true'

  const result = await apiAsync({
    baseURL: MINWAGE_BASE_PATH,
    api: url,
    method: 'GET'
  })

  return result.data
}


export default queryJurisdictionsWithMultipleTippedWages
